import {defineStore} from "pinia";

export const useControlIssueStore = defineStore('controlIssue', {
    state: () => ({
        controlIssue: {},
        controlIssues: [],
    }),
    actions: {
        setControlIssue(controlIssue) {
            this.controlIssue = controlIssue
        },
        setControlIssues(controlIssues) {
            this.controlIssues = controlIssues
        },
        addControlIssue(controlIssue) {
            this.controlIssues.unshift(controlIssue)
        },
        updateControlIssue(controlIssue) {
            let index = this.controlIssues.findIndex(cl => cl.id === controlIssue.id)
            this.controlIssues.splice(index, 1, controlIssue)
        },
        deleteControlIssue(controlIssue) {
            let index = this.controlIssues.findIndex(cl => cl.id === controlIssue.id)
            this.controlIssues.splice(index, 1)
        },
    },
});